import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable, from } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private readonly appEngineURLs: Array<string> = [
    environment.appEngineURL,
    environment.appEngineURLLocal
  ].filter((url): url is string => Boolean(url));

  constructor(private readonly auth: AngularFireAuth) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    if (!this.isAppEngineRequest(request.url)) {
      return next.handle(request);
    }

    return this.auth.authState.pipe(
      take(1),
      switchMap((user) => {
        if (!user) {
          return next.handle(request);
        }

        return from(user.getIdToken()).pipe(
          switchMap((token) => {
            if (!token) {
              return next.handle(request);
            }

            return next.handle(request.clone({
              setHeaders: {
                Authorization: `Bearer ${token}`
              }
            }));
          })
        );
      })
    );
  }

  private isAppEngineRequest(url: string): boolean {
    return this.appEngineURLs.some(baseURL => url.startsWith(baseURL));
  }
}
